import React, { useState, useEffect } from 'react'
import Layout from '../../../components/Admin/Layout'
import Subtitle from '../../../components/Admin/Subtitle'
import Loading from '../../../components/shared/Loading'
import MessageModal from '../../../components/shared/MessageModal'
import AdminService from '../../../services/AdminServices'
import Item from '../../../components/Admin/Item'
import './Users.scss'
import ModalForm from '../../../components/Admin/ModalForm'
import SimpleModal from '../../../components/shared/MessageModal'
import helperAdmin from '../../../utils/helperAdmin'

function Users() {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalWarning, setModalWarning] = useState(false)
  const [modalConflict, setModalConflict] = useState(false);
  const [profiles, setProfiles] = useState([])
  const [pickupPoints, setPickupPoints] = useState([])
  const [openModalForm, setModalForm] = useState(false)
  const [openModalPass, setModalPass] = useState(false)
  const [openMessage, setOpenMessage] = useState(false)
  const [error, setError] = useState({});
  const [user, setUser] = useState({
    name: '',
    password: '',
    profile: '',
    pickupPoint: []
  })

  useEffect(() => {
    fetchData()
    fetchProfiles()
    fetchPickUps()
    // eslint-disable-next-line
  }, [])

  async function fetchData() {
    try {
      setLoading(true)
      const users = await AdminService.getUsers()
      console.log(users);
      setData(formatData(users))
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const fetchPickUps = async () => {
    try {
      const pickups = await AdminService.getPickUpPoints();
      setPickupPoints(formatPickups(pickups));
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  async function fetchProfiles() {
    try {
      setLoading(true)
      const roles = await AdminService.getProfiles();
      console.log(roles);
      setProfiles(formatProfiles(roles))
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const formatProfiles = data => {
    return data.map(d => {
      d.label = d.title
      d.value = d.id
      return d
    })
  }

  const formatPickups = data => {
    return data.map(d => {
      d.label = d.title
      d.value = d.id
      return d
    })
  }

  const formatData = data => {
    return data.map(d => {
      d.name = d.username
      d.password = ''
      d.profile = d.roleId
      return d
    })
  }

  const clearUser = () => {
    setUser({
      name: '',
      password: '',
      profile: '',
      pickupPoint: []
    })
    setError({})
  }

  const clearUserPass = () => {
    setUser({
      ...user,
      password: '',
    })
    setError({})
  }

  const onClickEdit = async (d) => {
    setModalForm(true);
    const pickupPoint = await AdminService.getUserUbications(d.id);
    const formatted = pickupPoint.map(p => (
      p.pickupPointId
    ))
    setUser({
      ...d,
      pickupPoint: formatted
    })
  }

  const renderItems = () => {
    return data.map(d => (
      <Item
        key={d.id}
        onClickEdit={() => onClickEdit(d)}
        onClickDelete={() => { setOpenMessage(true); setUser(d) }}>
        <div className='user-item'>
          <p>{d.name}</p>
          <span>{d.role}</span>
        </div>
      </Item>
    ))
  }

  const handleChange = (evt, name) => {
    let newUser = { ...user }
    let value = evt.target ? evt.target.value : evt;
    const key = evt.target ? evt.target.name : name;
    if (key === 'profile') newUser.pickupPoint = [];
    // if(key === 'pickupPoint' && profile === 3) newUser.pickupPoint = [];
    console.log(value, key);
    setUser({ ...newUser, [key]: value });

    let newError = { ...error }
    if (newError[key]) newError = helperAdmin.removeKey(key, newError);
    setError(newError)
  }

  const handleCreateUser = async () => {
    console.log('handleCreateUser');
    setLoading(true)
    // Validar si campos vacios
    const newError = helperAdmin.validateUser({ ...user, profileSelected: profiles.find(p => p.id === user.profile) });

    console.log('newError', newError);
    // SI EL PICKUP ES UN NUMERO O NULL SE INTRODUCE EN UN ARRAY DE TODAS FORMAS
    let newPickups = [];
    newPickups = Array.isArray(user.pickupPoint) ? [...user.pickupPoint] : [user.pickupPoint]

    //validamos q el error no sea por contraseña
    if (newError && !newError.password) {
      setError(newError);
      // RETORNAR para parar la ejecucion
      if (Object.entries(newError).length !== 0 && newError.constructor === Object) return setLoading(false);
    }

    try {
      // CONDICION PARA CONSIDERAR EDITAR
      if (user.id) {
        await AdminService.updateUser(user.id, user.name, user.password, user.profile)
        const oldPickupPoints = await AdminService.getUserUbications(user.id);
        for (const oldpickup of oldPickupPoints) {
          const pickupFound = newPickups.find(pickup => pickup === oldpickup.pickupPointId);
          // SE ELIMINAN LOS PICKUPS QUE NO SE ENCUENTREN
          if (!pickupFound) await AdminService.deletePickupUser(user.id, oldpickup.pickupPointId);
        }
        for (const pickup of newPickups) {
          const pickupFound = oldPickupPoints.find(oldpickup => oldpickup.pickupPointId === pickup);
          // SE AÑADEN LOS PICKUPS NUEVOS
          if (!pickupFound) await AdminService.createPickupUser(user.id, pickup);
        }
      }
      // SINO SOLO SE CREA
      else {
        const response = await AdminService.createUser(user.name, user.password, user.profile);
        const { id: userId } = response[0];
        for (const pickup of newPickups) {
          await AdminService.createPickupUser(userId, pickup);
          console.log(pickup);
        }
      }
      fetchData()
      setLoading(false)
      setModalForm(false)
      clearUser();
    } catch (error) {
      console.error(error);
      setLoading(false)
      if (error.response && error.response.status === 409) setModalConflict(true);
      else setModalWarning(true)
    }
  }

  const handleDelete = async () => {
    try {
      setLoading(true)
      const oldPickupPoints = await AdminService.getUserUbications(user.id);
      for (const oldpickup of oldPickupPoints) {
        await AdminService.deletePickupUser(user.id, oldpickup.pickupPointId);
      };
      await AdminService.deleteUser(user.id);
      setLoading(false)
      clearUser()
      setOpenMessage(false)
      fetchData()
    } catch (e) {
      setLoading(false)
      setModalWarning(true)
    }
  }

  const handleChangePass = async () => {
    try {
      setLoading(true);
      const newError = helperAdmin.validateUserChangePassword({ ...user, profileSelected: profiles.find(p => p.id === user.profile) });
      setError(newError);
      if (Object.entries(newError).length !== 0 && newError.constructor === Object) return setLoading(false);
      const response = await AdminService.updateUserPass(user.id, user.password);
      console.log(response);
      setLoading(false);
      setModalPass(false);
      setModalForm(true);
      clearUserPass();
    } catch (error) {
      setLoading(false);
      console.error(error)
    }
  }

  return (
    <Layout>
      <Loading visible={loading} />
      <MessageModal visible={modalWarning} closeModal={() => setModalWarning(false)} message='No se pudo conectar al servicio. Revise su conexión' type={1} />
      <MessageModal
        visible={modalConflict}
        type={1}
        closeModal={() => setModalConflict(false)}
        message={'El nombre de usuario ya existe, intente con otro.'}
      />
      <ModalForm
        title='Usuario'
        visible={openModalForm}
        closeModal={() => { setModalForm(false); clearUser() }}
        onClickBtn1={() => { setModalForm(false); clearUser() }}
        onClickBtn2={handleCreateUser}

        updating={user.id}
        name={user.name}
        password={user.password}
        profile={user.profile}
        pickupPoint={user.pickupPoint}
        optionsProfile={profiles}
        optionsPickups={pickupPoints}
        onChange={handleChange}
        error={error}
        onClickBtnPass={() => { setModalPass(true); setModalForm(false) }}
      />
      <ModalForm
        title='Contraseña'
        visible={openModalPass}
        closeModal={() => { setModalPass(false); setModalForm(true); clearUserPass() }}
        onClickBtn1={() => { setModalPass(false); setModalForm(true); clearUserPass() }}
        onClickBtn2={handleChangePass}

        password={user.password}
        onChange={handleChange}
        error={error}
      />
      <SimpleModal
        visible={openMessage}
        closeModal={() => { setOpenMessage(false); clearUser() }}
        message='¿Desea eliminar el usuario seleccionado?'
        type={3}
        txtBtn1='Cancelar'
        txtBtn2='Eliminar'
        onClickBtn1={() => { setOpenMessage(false); clearUser() }}
        onClickBtn2={handleDelete}
      />
      <div className='user-container'>
        <Subtitle
          text='Usuarios'
          onClick={() => { setModalForm(true) }}
        />
        <div className='user-items'>
          {renderItems()}
        </div>
      </div>
    </Layout>
  )
}

export default Users
